var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('counter',{staticClass:"value",attrs:{"endVal":(_vm.endVal * 1),"decimals":_vm.$utils.decimals(_vm.endVal),"separator":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }